import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { FormRender } from '../../../../../forms/FormRenderer/types'
import FormRenderer from '../../../../../forms/FormRenderer'
import TableProductStockHistorys from './TableProductStockHistorys'
import useTableTypeStockSelector from '../../useTableTypeStockSelector'
import { TableProductStockBase } from '../../types'


type MainCheckStockProductProps = TableProductStockBase & {
    CurrencyId: string
}

const MainCheckStockProduct: React.FC<MainCheckStockProductProps> = ({ isVariantProduct, productType, ...rest }) => {
    const { t } = useTwinTranslation()
    const { dictTableTypeStock, tableType, setTableType } = useTableTypeStockSelector({ isVariantProduct, productType })
    let fieldsSelectorTable: FormRender<any> = []
    if (Object.keys(dictTableTypeStock).length > 1) {
        fieldsSelectorTable.push({
            cols: 2,
            elements: [
                {
                    name: 'tableType',
                    label: t('tableType', 'Tipo de tabla'),
                    component: 'CustomSelect',
                    value: tableType,
                    items: dictTableTypeStock,
                    onChange: setTableType
                },
            ]
        })
    }
    return (
        <div className='flex flex-col mb-10 flex-auto'>
            {fieldsSelectorTable.length > 0 ? <FormRenderer sections={fieldsSelectorTable} className='mb-20' /> : null}
            <TableProductStockHistorys showSpecialCases={Object.keys(dictTableTypeStock).length > 1} {...{ productType, isVariantProduct, tableType, ...rest }} />
        </div>
    )
}

export default MainCheckStockProduct